import { BaseWebComponentDataProviderFactory } from '../../../../../framework/BaseWebComponentDataProviderFactory';
import { API_TYPE_GZ } from '../../../../../webcomponents.constants';
import { MspInProductTrialsOverlayWindowsAppGzDataProvider } from '../dataProvider/MspInProductTrialsOverlayWindowsAppGzDataProvider';

export class MspInProductTrialsOverlayWindowsAppDataProviderFactory extends BaseWebComponentDataProviderFactory {
  constructor() {
    super();
    this.map.set(API_TYPE_GZ, MspInProductTrialsOverlayWindowsAppGzDataProvider);
  }
}
